import createStore from "@/utils/create-store";
import Model from "@/models/admin/wx-users";

export default createStore({ Model });
